module.exports = __webpack_public_path__ + "img/PhirePhox.7862d30e.png";